let VCA = VCA || {};

VCA.MyVCANavigationTabs = (function ($) {

    let ui = {};

    function cacheUI() {
        ui.$TabButton = $('.js-myvca-nav-tabs');
        ui.$TabContent = $('.js-myvca-tab-content');
        ui.$SelectBox = $('.js-myvca-nav-selectbox');
        ui.$MobileTigger = $('.js-myvca-tab-tigger');
    }

    function bindEvents() {
        ui.$TabButton.on('click', displayContentDesktop);
        ui.$SelectBox.on('change', displayContentMobile);
        ui.$MobileTigger.on('click', toggleMobile);
    }

    function toggleMobile() {
        let parent = $(this).closest('.myvca-left-nav__tabs-sidebar');
            parent.toggleClass('open');
    }

    function displayContentDesktop(e) {
        const btn = $(e.currentTarget);
        const sideBar = btn.parent('.myvca-left-nav__tabs-sidebar')[0];
        const tabsContainer = $(sideBar).parent('.myvca-left-nav__tabs')[0];
        const tabNumber = btn.data('for-tab');
        const tabToActivate = $(tabsContainer).find(`.myvca-left-nav__tab-content[data-tab="${tabNumber}"]`)[0];
        const mobileDropdownSelectToActivate = $('.myvca-left-nav__selectbox-select');
        let tabBtnIsActive = btn.hasClass('active');


        if (tabBtnIsActive) {
            return;
        }

        if(!tabToActivate){
            console.log('no tab call apt', tabToActivate);
            return;
        }

        ui.$TabButton.each((idx,btn) => {
            $(btn).removeClass('active');
        });

        ui.$TabContent.each((idx,contentContainer) => {
            $(contentContainer).removeClass('active');
        });

        btn.addClass('active');
        $(tabToActivate).addClass('active');
        mobileDropdownSelectToActivate.val(tabNumber);
    }

    function displayContentMobile(e) {
        const selectOption = $(e.currentTarget);
        const selectOptionValue = $(selectOption).val();
        const tabsParentContainer = selectOption.closest('.myvca-left-nav__tabs')[0];
        const tabToActivateMobile = $(tabsParentContainer).find(`.myvca-left-nav__tab-content[data-tab="${selectOptionValue}"]`)[0];

        ui.$TabContent.each((idx,contentContainer) => {
            $(contentContainer).removeClass('active');
        });

        ui.$TabButton.each((idx,btn) => {
            $(btn).removeClass('active');
        });

        $(ui.$SelectBox).attr('data-value', selectOptionValue);
        $(tabToActivateMobile).addClass('active');
        $(tabsParentContainer).find(`.myvca-left-nav__tabs-btn[data-for-tab="${selectOptionValue}"]`).addClass('active');
    }

    function init() {
        if ($('.myvca-left-nav').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.MyVCANavigationTabs.init();
    });
});

